import { IApplyAuthService, IApplyInfo, ApplyResult } from '@src/slide/application/service/apply-auth-service/core/interface';
import { getBkn, getXSRF } from '@src/slide/domain/slide-app/utils/cookie-utils';
import axios from 'axios';
import { RUNTIME } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { IApplyAuthInjectable } from '@src/slide/application/service/apply-auth-service/inject/interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { isLicenseValid } from '@src/js/common/getPrivilegeAttr';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import { showPermitApply } from '@src/js/common/ark-extensions/dc-components/docs-component-permit-apply';
import { redirectToScenario } from '@src/slide/application/service/apply-auth-service/core/jumpToScenario';
import { shouldDisableNetwork } from '@src/slide/infrastructure/module/dependent/socket';

export default class ApplyAuthService implements IApplyAuthService {
    // 权限申请状态信息
    private mApplyInfo: IApplyInfo;

    public constructor(private inject: IApplyAuthInjectable) {}
    /**
     * 初始化，会触发申请状态信息拉取
     */
    public async init(): Promise<void> {
        const { domainId = '', padId = '' } = SlideDataServices.DocInfoManager() ?? {};
        await this.checkIsApplyIn24H(domainId, padId);
    }
    /**
     * 触发申请编辑权限动作
     */
    public handleApplyEdit(): void {
        // 如果已经申请过，弹出已申请的提示
        if (this.hasApplied) {
            const docInfo = SlideDataServices.DocInfoManager()?.docInfo;
            redirectToScenario(docInfo?.owner_nick || '', 'edit', this.inject.shouldDisableGuideBtns());
            return;
        }

        const callback = () => {
            this.mApplyInfo = { hasApplied: true, applyResult: ApplyResult.NotHandle };
        };
        showPermitApply({
            onSubmitted: callback,
        });
    }

    /**
     * 是否可以申请编辑权限
     */
    public canApplyEdit(): boolean {
        if (!isLicenseValid()) return false;
        const canApplyEditAttr = get(window.clientVars, 'privilegeAttribute.can_apply_edit');
        if (isUndefined(canApplyEditAttr)) {
            return true;
        }
        return canApplyEditAttr;
    }

    /**
     * 拉取24小时内的权限申请状态
     * @param domainId  文档信息
     * @param padId
     */
    public async checkIsApplyIn24H(domainId: string, padId: string): Promise<IApplyInfo> {
        // 兜底默认数据
        let result = { hasApplied: false, applyResult: '' };
        if (!shouldDisableNetwork()) {
            result = await axios
                .get(`${this.getApplyCGI()}?domainId=${domainId}&localPadId=${padId}&xsrf=${getXSRF()}&bkn=${getBkn()}`)
                .then((res) => {
                    let { data } = res;
                    let hasApplied = false;
                    let applyResult = '';
                    if (data?.result?.retcode) { // 私有化场景返回的数据在data.result里
                        data = data.result;
                    }
                    if (data && data.retcode === 10004) { // 原有的已申请可读权限返回10003不变 // 当用户已申请可编辑权限时返回10004
                        hasApplied = true;
                        if (data.pass === '0') {
                            applyResult = ApplyResult.NotPass;
                        } else if (data.pass === '1') {
                            applyResult = ApplyResult.Pass;
                        } else if (!data.pass) {
                            applyResult = ApplyResult.NotHandle;
                        }

                        if (data.rightFlag === '0') {
                            applyResult = ApplyResult.NotPass;
                        }
                    }
                    return { hasApplied, applyResult };
                })
                .catch(() => ({ hasApplied: false, applyResult: '' }));
        }
        this.mApplyInfo = result;
        return result;
    }

    /**
     * 是否已申请
     */
    public get hasApplied(): boolean {
        return this.applyInfo?.hasApplied;
    }

    /**
     * 获取applyInfo
     */
    public get applyInfo(): IApplyInfo {
        return this.mApplyInfo;
    }

    /**
     * 获取cgi
     * @private
     */
    private getApplyCGI(): string {
        const docsBaseUrl = RUNTIME.API_ROOT;
        return `${docsBaseUrl}${this.inject.getApplyCGI()}`;
    }
}
